import { useTranslation } from 'react-i18next';
import { useFlag } from '../redux/flags/hooks/useFlag';
import { useSelector, useDispatch } from 'react-redux';
import { getUserWatchState } from './redux/selectors';
import { useMemo, useCallback } from 'react';
import { BiEventType } from '../biLogger/constants';
import { clickWatch } from './redux/actionCreators';
function useWatchButtonText(isWatching, isWatchingBack) {
    var t = useTranslation().t;
    var swapWatchWithFollow = useFlag('swap_watch_follow');
    if (isWatching) {
        return swapWatchWithFollow
            ? t('watchButton.following')
            : t('watchButton.watching');
    }
    if (isWatchingBack) {
        return swapWatchWithFollow
            ? t('watchButton.followBack')
            : t('watchButton.watchBack');
    }
    return swapWatchWithFollow ? t('watchButton.follow') : t('watchButton.watch');
}
export function useWatchButton(user, initialIsWatching, isWatchingBack, disabled, onToggleWatchSuccess) {
    if (initialIsWatching === void 0) { initialIsWatching = !!(user === null || user === void 0 ? void 0 : user.isWatching); }
    if (isWatchingBack === void 0) { isWatchingBack = false; }
    if (disabled === void 0) { disabled = false; }
    var _a = useSelector(function (state) {
        return getUserWatchState(state, user, { isWatching: initialIsWatching });
    }), isWatching = _a.isWatching, isLoading = _a.isLoading;
    var dispatch = useDispatch();
    var text = useWatchButtonText(isWatching, isWatchingBack);
    var biData = useMemo(function () { return ({
        evid: BiEventType.WATCH_AUTHOR,
        is_watching: isWatching ? 0 : 1,
        friendid: user === null || user === void 0 ? void 0 : user.useridUuid,
    }); }, [isWatching, user]);
    var onClick = useCallback(function () {
        if (disabled || !user) {
            return;
        }
        dispatch(clickWatch(user, isWatching, onToggleWatchSuccess));
    }, [user, isWatching, disabled, onToggleWatchSuccess, dispatch]);
    return {
        text: text,
        onClick: onClick,
        isLoading: isLoading,
        isWatching: isWatching,
        biData: biData,
    };
}
//# sourceMappingURL=useWatchButton.js.map